import { Button } from '@mui/material';
import Dialog from 'components/dialog';
import FilterSidebar from 'components/filter-sidebar';
import { useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { usePondsState } from 'views/production-systems/context/ponds-context';
import ManageAerators from 'views/production-systems/features/farm-setup/components/manage-aerators';
import ManageFeeders from 'views/production-systems/features/farm-setup/components/manage-feeders';
import { Pond } from 'views/production-systems/features/farm-setup/types/pond.type';

const PAGE_NAME_ID = 'productionSystems.farmSetup';

type SortablePond = Pond & {
  status: boolean;
};

type Props = {
  ponds: SortablePond[];
};

const SetupActions: React.FC<Props> = ({ ponds }) => {
  const intl = useIntl();

  const { lockPonds, lockedPonds, releasePonds, selectedPonds } = usePondsState();

  const manageAeratorsDialogRef = useRef<React.ElementRef<typeof Dialog>>(null);
  const manageFeedersDialogRef = useRef<React.ElementRef<typeof Dialog>>(null);

  const handleClick = () => {
    lockPonds(selectedPonds);
  };

  const handleDialogClose = () => {
    if (!!lockedPonds?.granted.length || !!lockedPonds?.notGranted.length) {
      releasePonds(lockedPonds.granted);
    }
    manageAeratorsDialogRef.current?.setOpen(false);
    manageFeedersDialogRef.current?.setOpen(false);
  };

  const isActionEnabled = () => !(selectedPonds.length > 0);

  return (
    <FilterSidebar>
      <Dialog
        ref={manageAeratorsDialogRef}
        onClose={handleDialogClose}
        title={intl.formatMessage({ id: `${PAGE_NAME_ID}.buttons.manageAerators` })}
        maxWidth="lg"
        button={
          <Button onClick={handleClick} disabled={isActionEnabled()} sx={{ width: { xs: '100%', md: 'auto' } }}>
            <FormattedMessage id={`${PAGE_NAME_ID}.buttons.manageAerators`} />
          </Button>
        }>
        <ManageAerators ponds={ponds?.filter((p) => selectedPonds.includes(p.pondId)) || []} handleClose={handleDialogClose} />
      </Dialog>
      <Dialog
        ref={manageFeedersDialogRef}
        onClose={handleDialogClose}
        title={intl.formatMessage({ id: `${PAGE_NAME_ID}.buttons.manageFeeders` })}
        maxWidth="xl"
        button={
          <Button onClick={handleClick} disabled={isActionEnabled()} sx={{ width: { xs: '100%', md: 'auto' } }}>
            <FormattedMessage id={`${PAGE_NAME_ID}.buttons.manageFeeders`} />
          </Button>
        }>
        <ManageFeeders ponds={ponds?.filter((p) => selectedPonds.includes(p.pondId)) || []} handleClose={handleDialogClose} />
      </Dialog>
    </FilterSidebar>
  );
};

export default SetupActions;
